import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import FormInput from "components/atoms/input/FormInput";
import { validateTitleTextMaxLength } from "components/validations/alert";

import AbstractModal from "components/page/modal/AbstractModal";

import { useNoteCreate } from "hooks/queries/useNote";
import { useUser } from "hooks/queries/useUser";

import { genericEnterKeyDown } from "utils/validation";

const Container = styled.div`
    width: 100%;
`;

function NoteAddModal(props) {
    const [displayName, setDisplayName] = useState("");
    const inputRef = useRef(null);
    const noteMutation = useNoteCreate();
    const userQuery = useUser();
    const [user, setUser] = useState({});

    useEffect(() => {
        if (userQuery.data) {
            setUser(userQuery.data);
        }
    }, [userQuery.data]);

    const addNote = () => {
        if (
            !validateTitleTextMaxLength(displayName, () => {
                inputRef.current?.focus();
            })
        ) {
            return;
        }

        noteMutation.mutate(
            {
                display_name: displayName,
                ai_response_language: user.env_ai_language,
                citation_style: user.env_citation_style,
            },
            {
                onSuccess: (data) => {
                    props.onSuccess(data);
                    props.exitModal();
                },
                onError: (error) => {
                    console.log(error);
                },
            },
        );
    };

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    return (
        <AbstractModal
            modalTitle="연구노트 추가"
            width={480}
            exitModal={props.exitModal}
            footer={{
                leftBtnText: "취소",
                rightBtnText: "확인",
                leftOnClick: props.exitModal,
                rightOnClick: addNote,
            }}
        >
            <Container>
                <FormInput
                    labelDp="none"
                    placeholder="제목을 입력하세요."
                    value={displayName}
                    onChange={(e) => setDisplayName(e.target.value)}
                    onKeyDown={(e) => {
                        genericEnterKeyDown(e, addNote);
                    }}
                    ref={inputRef}
                />
            </Container>
        </AbstractModal>
    );
}

export default NoteAddModal;
